import $ from 'jquery';
export default {
    inserted(el) {
        if ($(el).height() > 23 * 2) {
            $(el)
                .addClass('show-ellipsis')
                .css({
                    maxHeight: '42px',
                    overflow: 'hidden',
                });
        }
    },
};
